import { Box, Container, Grid } from "@mui/material";
import { StyledHeadingWithGradientunderline } from "@Styled/Pages/Landing/Category";
import {
  StyledContent,
  StyledGridContainer,
  StyledTitle,
} from "@Styled/Pages/Prefooter";

const InterestFreePaymentOptions = () => {
  return (
    <>
      <Container sx={{ marginBottom: "5rem" }}>
        <StyledGridContainer container>
          <StyledHeadingWithGradientunderline
            variant="subtitle1"
            sx={{
              fontSize: { sm: "1.5rem", xs: "1.2rem" },
              letterSpacing: "-1px",
            }}
          >
            INTEREST FREE PAYMENT OPTIONS{" "}
          </StyledHeadingWithGradientunderline>
        </StyledGridContainer>
        <StyledContent>
          {" "}
          Now you can buy any econut product on our website with 0 interest
          installments in 3 months via simpl. Please call us at{" "}
          <a href="tel:+91-85913 67993" style={{ color: "#00844a" }}>
            +91-85913 67993
          </a>{" "}
          email us at{" "}
          <a href="mailto: info@econut.store" style={{ color: "#00844a" }}>
            info@econut.store
          </a>
        </StyledContent>
      </Container>
    </>
  );
};
export default InterestFreePaymentOptions;
